import { WEATHER_STATUS_IMAGES } from '../../constants/image.constant';

export const WEATHER_TYPE = {
    CLEAR: 'clear',
    FG: 'FG',
    MOD_CLOUDY: 'modCloudy',
    MOST_CLEAR: 'mostClear',
    OVERCAST: 'overcast',
    PART_CLOUDY: 'partCloudy',
    PREV_CLOUDY: 'prevCloudy',
    RAIN: 'rain',
    SLIGHT_CLOUDY: 'slightCloudy',
    SNOW: 'snow',
    THUNDERSTORM: 'thunderstorm'
};

export const icons = {
    [WEATHER_TYPE.CLEAR]: WEATHER_STATUS_IMAGES.CLEAR,
    [WEATHER_TYPE.FG]: WEATHER_STATUS_IMAGES.FG,
    [WEATHER_TYPE.MOD_CLOUDY]: WEATHER_STATUS_IMAGES.MOD_CLOUDY,
    [WEATHER_TYPE.MOST_CLEAR]: WEATHER_STATUS_IMAGES.MOST_CLEAR,
    [WEATHER_TYPE.OVERCAST]: WEATHER_STATUS_IMAGES.OVERCAST,
    [WEATHER_TYPE.PART_CLOUDY]: WEATHER_STATUS_IMAGES.PART_CLOUDY,
    [WEATHER_TYPE.PREV_CLOUDY]: WEATHER_STATUS_IMAGES.PREV_CLOUDY,
    [WEATHER_TYPE.RAIN]: WEATHER_STATUS_IMAGES.RAIN,
    [WEATHER_TYPE.SLIGHT_CLOUDY]: WEATHER_STATUS_IMAGES.SLIGHT_CLOUDY,
    [WEATHER_TYPE.SNOW]: WEATHER_STATUS_IMAGES.SNOW,
    [WEATHER_TYPE.THUNDERSTORM]: WEATHER_STATUS_IMAGES.THUNDERSTORM
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/service/weather.constant.js